import React from 'react';
import { MdMenu } from '@react-icons/all-files/md/MdMenu';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { MdInfo } from '@react-icons/all-files/md/MdInfo';
import { MdInsertInvitation } from '@react-icons/all-files/md/MdInsertInvitation';
import { MdLocalShipping } from '@react-icons/all-files/md/MdLocalShipping';
import { MdSupervisorAccount } from '@react-icons/all-files/md/MdSupervisorAccount';
import { MdDashboard } from '@react-icons/all-files/md/MdDashboard';
import { MdPayment } from '@react-icons/all-files/md/MdPayment';
import { MdDateRange } from '@react-icons/all-files/md/MdDateRange';
import { MdAirportShuttle } from '@react-icons/all-files/md/MdAirportShuttle';
import { MdPages } from '@react-icons/all-files/md/MdPages';
import { MdFlight } from '@react-icons/all-files/md/MdFlight';
import { MdArrowBack } from '@react-icons/all-files/md/MdArrowBack';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import { MdArrowUpward } from '@react-icons/all-files/md/MdArrowUpward';
import { MdArrowDownward } from '@react-icons/all-files/md/MdArrowDownward';
import { MdSearch } from '@react-icons/all-files/md/MdSearch';
import { MdSend } from '@react-icons/all-files/md/MdSend';
import { MdCheckCircle } from '@react-icons/all-files/md/MdCheckCircle';
import { MdWidgets } from '@react-icons/all-files/md/MdWidgets';
import { MdBusinessCenter } from '@react-icons/all-files/md/MdBusinessCenter';
import { MdPeople } from '@react-icons/all-files/md/MdPeople';
import { MdArrowDropDown } from '@react-icons/all-files/md/MdArrowDropDown';
import { MdVisibility } from '@react-icons/all-files/md/MdVisibility';
import { MdDone } from '@react-icons/all-files/md/MdDone';
import { MdAccessTime } from '@react-icons/all-files/md/MdAccessTime';
import { MdLocationOn } from '@react-icons/all-files/md/MdLocationOn';
import { MdMail } from '@react-icons/all-files/md/MdMail';
import { MdLocalPhone } from '@react-icons/all-files/md/MdLocalPhone';
import { MdFileDownload } from '@react-icons/all-files/md/MdFileDownload';
import { MdChevronLeft } from '@react-icons/all-files/md/MdChevronLeft';
import { MdChevronRight } from '@react-icons/all-files/md/MdChevronRight';
import { MdRoomService } from '@react-icons/all-files/md/MdRoomService';
import { MdModeEdit } from '@react-icons/all-files/md/MdModeEdit';
import { MdLoyalty } from '@react-icons/all-files/md/MdLoyalty';
import { MdMouse } from '@react-icons/all-files/md/MdMouse';
import { MdMonetizationOn } from '@react-icons/all-files/md/MdMonetizationOn';
import { MdFileUpload } from '@react-icons/all-files/md/MdFileUpload';
import { MdInsertEmoticon } from '@react-icons/all-files/md/MdInsertEmoticon';
import { MdComputer } from '@react-icons/all-files/md/MdComputer';
import { MdHourglassEmpty } from '@react-icons/all-files/md/MdHourglassEmpty';
import { MdLocalAtm } from '@react-icons/all-files/md/MdLocalAtm';
import { MdCancel } from '@react-icons/all-files/md/MdCancel';
import { MdAttachMoney } from '@react-icons/all-files/md/MdAttachMoney';
import { MdContentCopy } from '@react-icons/all-files/md/MdContentCopy';
import { MdTimer } from '@react-icons/all-files/md/MdTimer';
import { MdLanguage } from '@react-icons/all-files/md/MdLanguage';
import { MdVpnKey } from '@react-icons/all-files/md/MdVpnKey';
import { MdMore } from '@react-icons/all-files/md/MdMore';
import { MdLocalOffer } from '@react-icons/all-files/md/MdLocalOffer';
import { MdColorLens } from '@react-icons/all-files/md/MdColorLens';
import { MdHome } from '@react-icons/all-files/md/MdHome';
import { MdCode } from '@react-icons/all-files/md/MdCode';
import { MdLibraryBooks } from '@react-icons/all-files/md/MdLibraryBooks';
import { MdPortrait } from '@react-icons/all-files/md/MdPortrait';
import { MdWork } from '@react-icons/all-files/md/MdWork';
import { MdGroup } from '@react-icons/all-files/md/MdGroup';
import { MdMoreHoriz } from '@react-icons/all-files/md/MdMoreHoriz';
import { MdPublic } from '@react-icons/all-files/md/MdPublic';
import { MdKeyboardArrowUp } from '@react-icons/all-files/md/MdKeyboardArrowUp';
import { MdContentPaste } from '@react-icons/all-files/md/MdContentPaste';
import { MdSecurity } from '@react-icons/all-files/md/MdSecurity';
import { MdBubbleChart } from '@react-icons/all-files/md/MdBubbleChart';
import { MdAirplanemodeActive } from '@react-icons/all-files/md/MdAirplanemodeActive';
import { MdLineStyle } from '@react-icons/all-files/md/MdLineStyle';
import { MdDirectionsBoat } from '@react-icons/all-files/md/MdDirectionsBoat';
import { MdShoppingCart } from '@react-icons/all-files/md/MdShoppingCart';
import { MdHelpOutline } from '@react-icons/all-files/md/MdHelpOutline';
import { MdPersonOutline } from '@react-icons/all-files/md/MdPersonOutline';
import { MdGavel } from '@react-icons/all-files/md/MdGavel';
import { MdAssignment } from '@react-icons/all-files/md/MdAssignment';
import { MdStar } from '@react-icons/all-files/md/MdStar';
import { MdOpenWith } from '@react-icons/all-files/md/MdOpenWith';
import { MdEnhancedEncryption } from '@react-icons/all-files/md/MdEnhancedEncryption';
import { MdBook } from '@react-icons/all-files/md/MdBook';
import { MdViewCompact } from '@react-icons/all-files/md/MdViewCompact';
import { MdChromeReaderMode } from '@react-icons/all-files/md/MdChromeReaderMode';
import { MdHourglassFull } from '@react-icons/all-files/md/MdHourglassFull';
import { MdAirlineSeatLegroomExtra } from '@react-icons/all-files/md/MdAirlineSeatLegroomExtra';
import { MdKeyboardArrowDown } from '@react-icons/all-files/md/MdKeyboardArrowDown';
import { FaLinkedinIn } from '@react-icons/all-files/fa/FaLinkedinIn';
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import { AiFillStar } from '@react-icons/all-files/ai/AiFillStar';
import { GiSofa } from '@react-icons/all-files/gi/GiSofa';
import { IoNewspaperSharp } from '@react-icons/all-files/io5/IoNewspaperSharp';
import { RiEmotionLine } from '@react-icons/all-files/ri/RiEmotionLine';
import { FaCodeBranch } from '@react-icons/all-files/fa/FaCodeBranch';
import { GiSpeedometer } from '@react-icons/all-files/gi/GiSpeedometer';

const components = {
  MdClose,
  MdInfo,
  MdInsertInvitation,
  MdLocalShipping,
  MdSupervisorAccount,
  MdDashboard,
  MdPayment,
  MdDateRange,
  MdAirportShuttle,
  MdPages,
  MdFlight,
  MdArrowBack,
  MdArrowForward,
  MdArrowUpward,
  MdArrowDownward,
  MdSearch,
  MdSend,
  MdWidgets,
  MdBusinessCenter,
  MdPeople,
  MdArrowDropDown,
  MdVisibility,
  MdDone,
  MdAccessTime,
  MdLocationOn,
  MdMail,
  MdLocalPhone,
  MdFileDownload,
  MdChevronLeft,
  MdChevronRight,
  MdRoomService,
  MdModeEdit,
  MdLoyalty,
  MdMouse,
  MdMonetizationOn,
  MdFileUpload,
  MdInsertEmoticon,
  MdComputer,
  MdHourglassEmpty,
  MdLocalAtm,
  MdCancel,
  MdAttachMoney,
  MdContentCopy,
  MdTimer,
  MdLanguage,
  MdVpnKey,
  MdMore,
  MdLocalOffer,
  MdColorLens,
  MdHome,
  MdCode,
  MdLibraryBooks,
  MdPortrait,
  MdWork,
  MdGroup,
  MdMoreHoriz,
  MdPublic,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdContentPaste,
  MdSecurity,
  MdBubbleChart,
  MdAirplanemodeActive,
  MdLineStyle,
  MdDirectionsBoat,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
  MdCheckCircle,
  MdColorLens,
  MdLocalOffer,
  MdShoppingCart,
  MdAirportShuttle,
  MdPortrait,
  MdWork,
  MdMail,
  MdHelpOutline,
  MdPersonOutline,
  MdLocalOffer,
  MdGavel,
  MdHome,
  MdInsertEmoticon,
  MdAssignment,
  MdStar,
  MdOpenWith,
  MdBook,
  MdEnhancedEncryption,
  MdChromeReaderMode,
  MdAirlineSeatLegroomExtra,
  MdHourglassFull,
  GiSofa,
  AiFillStar,
  IoNewspaperSharp,
  RiEmotionLine,
  MdViewCompact,
  FaCodeBranch,
  GiSpeedometer,
  MdMenu
};

export default function Icon({ icon, additionalClassNames }) {
  if (!components[icon]) {
    console.log(`Icon ${icon} not found`);
  }
  const Icon = components[icon] || MdHelpOutline;
  return <Icon icon={icon} className={`icon ${additionalClassNames}`} />;
}
